import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Button } from '@fabric-app/ui/components/Button';
import { Kbd } from '@fabric-app/ui/components/Kbd';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { styled } from 'styled-components';
import { IconNewTag, IconEnter, IconShock } from '@fabric-app/icons/old';
import { useMemo } from 'react';
import { TagBadge } from './TagBadge.js';

const ListContainer = styled.div.withConfig({
  displayName: "TagsList__ListContainer",
  componentId: "sc-44d6dde-0"
})([
  `display:flex;flex-direction:column;gap:1rem;`
]);
const Bold = styled.strong.withConfig({
  displayName: "TagsList__Bold",
  componentId: "sc-44d6dde-1"
})([
  `font-weight:700;`
]);
const StatusText = styled.div.withConfig({
  displayName: "TagsList__StatusText",
  componentId: "sc-44d6dde-2"
})([
  `font-size:15px;color:`,
  `;padding:8px 15px;`
], cssVar["color-text-secondary"]);
const TAG_SUGGESTION_GROUP = "_";
const TagsList = ({ tags, isLoading, searchQuery, onSelect }) => {
  const isSearchExactAsAnyTag = tags?.some((tag) => tag.name === searchQuery?.toLowerCase());
  const groupedTagsByFirstLetter = useMemo(() => {
    const grouped = (tags || [])?.reduce((acc, tag) => {
      if (tag.suggested) {
        acc[TAG_SUGGESTION_GROUP] = acc[TAG_SUGGESTION_GROUP] || [];
        acc[TAG_SUGGESTION_GROUP].push(tag);
        return acc;
      }
      const firstLetter = tag.name[0].toUpperCase();
      acc[firstLetter] = acc[firstLetter] || [];
      acc[firstLetter].push(tag);
      return acc;
    }, {});
    return Object.entries(grouped).sort((a, b) => a[0].localeCompare(b[0])).map(([letter, tags2]) => {
      if (letter === TAG_SUGGESTION_GROUP) {
        return [
          letter,
          tags2
        ];
      }
      return [
        letter,
        tags2.sort((a, b) => a.name.localeCompare(b.name))
      ];
    });
  }, [
    tags
  ]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      !isLoading && !isSearchExactAsAnyTag && searchQuery && /* @__PURE__ */ jsxs(Button, {
        variant: "icon",
        type: "submit",
        size: "lg",
        style: {
          width: "100%"
        },
        children: [
          /* @__PURE__ */ jsx(IconNewTag, {
            style: {
              width: "20px",
              height: "22px"
            }
          }),
          /* @__PURE__ */ jsxs("span", {
            children: [
              "Create tag ",
              /* @__PURE__ */ jsxs(Bold, {
                children: [
                  "“",
                  searchQuery,
                  "”"
                ]
              })
            ]
          }),
          /* @__PURE__ */ jsx(Kbd, {
            style: {
              marginLeft: "auto"
            },
            children: /* @__PURE__ */ jsx(IconEnter, {})
          })
        ]
      }),
      Boolean(tags?.length) && /* @__PURE__ */ jsx(ListContainer, {
        children: groupedTagsByFirstLetter.map(([letter, tags2]) => /* @__PURE__ */ jsxs(TagGroup, {
          children: [
            /* @__PURE__ */ jsx(TagGroupHeader, {
              children: letter === TAG_SUGGESTION_GROUP ? /* @__PURE__ */ jsx(IconShock, {
                style: {
                  color: cssVar["color-text-quaternary"]
                }
              }) : letter
            }),
            tags2.map((tag) => /* @__PURE__ */ jsx(TagBadge, {
              tag,
              onSelect
            }, tag.id))
          ]
        }, letter))
      }),
      isLoading && Boolean(!tags?.length) && /* @__PURE__ */ jsx(StatusText, {
        children: "Loading..."
      }),
      !isLoading && !tags?.length && !searchQuery && /* @__PURE__ */ jsx(StatusText, {
        children: "No tags found"
      })
    ]
  });
};
const TagGroup = styled.div.withConfig({
  displayName: "TagsList__TagGroup",
  componentId: "sc-44d6dde-3"
})([
  `display:flex;flex-direction:column;gap:10px;`
]);
const TagGroupHeader = styled.div.withConfig({
  displayName: "TagsList__TagGroupHeader",
  componentId: "sc-44d6dde-4"
})([
  `padding:18px 4px 4px 4px;font-size:18px;line-height:22px;font-weight:600;color:rgba(`,
  `,0.4);height:44px;display:flex;align-items:flex-end;`
], cssVar["color-text-primary-rgb"]);

export { TagsList as default };
//# sourceMappingURL=TagsList.js.map
